import React, { Component } from 'react';

import './MaximizeButton.css'
export class MaximizeButton extends Component {
    render() {
        return (
            <div className='maximizeButton' 
            style={{ 
                width: this.props.width ? this.props.width : '35px', 
                height: this.props.height ? this.props.height : '35px',
                lineHeight: `${this.props.height ? this.props.height : 35}px`
            }}
            onClick={this.props.onClick}>
                <div className='maximizeButton__content'
                    style={{
                        width: `${this.props.width ? this.props.width-10 : 25}px`,
                        height: `${this.props.height ? this.props.width-10 : 25}px`
                    }}/>
            </div>
        );
    }
}